"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OWNER = exports.MANAGING_EXECUTIVE = exports.DIRECTOR = exports.OFFICER = exports.PARTNER = exports.MEMBER = void 0;
var MEMBER = 'member';
exports.MEMBER = MEMBER;
var PARTNER = 'partner';
exports.PARTNER = PARTNER;
var OFFICER = 'officer';
exports.OFFICER = OFFICER;
var DIRECTOR = 'director';
exports.DIRECTOR = DIRECTOR;
var MANAGING_EXECUTIVE = 'managingExecutive';
exports.MANAGING_EXECUTIVE = MANAGING_EXECUTIVE;
var OWNER = 'owner';
exports.OWNER = OWNER;